import { render, staticRenderFns } from "./CardCourse.vue?vue&type=template&id=12c74f04&"
import script from "./CardCourse.vue?vue&type=script&lang=js&"
export * from "./CardCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports